<section id="Edalat">
    <div class="row">
        <div class="title-section">
            <h3>فروش سهام عدالت</h3>
            <a target="_blank" [routerLink]="['/services/saham-edalat']">
                <h6>سهام عدالت چیست؟</h6>
            </a>
        </div>
        <div class="body-section">
            <div class="column medium-8">
                <ul class="wpfs accordion your_custom_class" data-accordion="">
                    <li class="wpfs accordion-navigation">
                        <a aria-expanded="false">افراد مجاز به فروش سهام عدالت</a>
                        <div id="panel-se-1" class="content">
                            <p>اشخاصی که در سایت <a target="_blank" href="http://samanese.ir"
                                    rel="noopener"><strong>samanese.ir</strong></a> شماره شبا و شماره موبایل خود را ثبت
                                و روش مستقیم را انتخاب نموده اند، می توانند ۶۰ درصد از سهام خود را به فروش برسانند.</p>
                        </div>
                    </li>
                    <li class="wpfs accordion-navigation">
                        <a aria-expanded="false">فروش سهام عدالت</a>
                        <div id="panel-se-2" class="content">
                            <p>اگر روش مستقیم را برای فروش سهام عدالت انتخاب نموده اید به <strong><a
                                        href="http://abanse.etadbir.com/login.html" target="_blank"
                                        rel="noopener">سامانه فروش سهام
                                        عدالت کارگزاری آبان</a></strong> مراجعه نمایید و
                                روی گزینه “ثبت نام” کلیک نمایید. کد ملی و شماره موبایل خود را وارد کنید، پس از دریافت
                                پیامک کد تایید روی شماره موبایل خود و وارد نمودن آن در سامانه، می توانید نسبت به تعیین
                                نام کاربری(کد ملی) و کلمه عبور اقدام نمایید. در این مرحله می توانید نسبت به مشاهده و ثبت
                                درخواست فروش دارایی خود اقدام نمایید.</p>
                        </div>
                    </li>
                    <li class="wpfs accordion-navigation">
                        <a aria-expanded="false">دریافت وجه حاصل از فروش سهام عدالت</a>
                        <div id="panel-se-3" class="content">
                            <p>پس از فروش سهام عدالت، چنانچه در سامانه، گزینه واریز وجه به حساب را انتخاب کرده باشید،
                                مبلغ مورد نظر به شماره حساب ثبت شده شما در سامانه سهام عدالت واریز خواهد شد.</p>
                        </div>
                    </li>
                    <li class="wpfs accordion-navigation">
                        <a aria-expanded="false">دریافت کد بورسی و معاملات آنلاین با آبان</a>
                        <div id="panel-se-4" class="content">
                            <p>اگر علاقمند به سرمایه گذاری در بورس هستید و قصد خرید و فروش سهام را دارید، در سایت
                                <strong><a href="https://ehraz.aban.net" target="_blank"
                                        rel="noopener">https://ehraz.aban.net</a></strong>
                                ثبت نام کنید، سپس برای احراز
                                هویت به دفاتر پیشخوان که در پایان ثبت نام معرفی شده است مراجعه نمایید. چند روز بعد نام
                                کاربری و کلمه عبور برای شما ایمیل و پیامک می شود.
                            </p>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="column medium-3">
                <a target="_blank" [routerLink]="['/services/sell-edalat']" class="button white-button">اطلاعات
                    بیشتر</a>
            </div>
            <div class="column medium-3">
                <a href="https://abanse.etadbir.com/login.html" target="_blank" class="button red-button">سامانه فروش
                    سهام عدالت</a>
            </div>
        </div>
    </div>
</section>